/**
 * Raumguide für Schulen (snippets/referenz-raumguide.liquid).
 * Räume anlegen, kopieren, entfernen; Bestandsaufnahme als Text zusammenstellen, vor dem
 * Absenden anzeigen und in contact[body] schreiben. Zwischenstand im sessionStorage des
 * Tabs, damit ein Reload (Fehlermeldung, Spam-Prüfung) nichts verliert.
 */
(() => {
  const root = document.querySelector('[data-ref-guide]');
  if (!root) return;
  const form = root.querySelector('form');
  const $ = (s) => root.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const SPEICHER = 'fennext-raumguide';
  const liste = $('[data-rg-liste]');
  const vorlage = $('[data-rg-vorlage]');
  const eingabe = $('[data-rg-eingabe]');
  const ueberblick = $('[data-rg-ueberblick]');
  const fehler = $('[data-rg-fehler]');
  let naechsteId = 1;

  // Ohne JavaScript bleibt das einfache Formular; mit JavaScript gibt es Räume und Überblick.
  $$('[data-rv-js]').forEach((el) => {
    el.hidden = false;
  });
  $('[data-rg-direkt]').hidden = true;
  form.noValidate = true;

  /* ── Hilfen ── */
  const zahl = (wert) => {
    const n = Number.parseFloat(String(wert || '').replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const deutsch = (n, stellen = 1) => n.toLocaleString('de-DE', { maximumFractionDigits: stellen });
  const wert = (el, k) => {
    const felder = $$(`[data-k="${k}"]`, el);
    if (felder[0]?.type === 'checkbox') return felder.filter((f) => f.checked).map((f) => f.value);
    return (felder[0]?.value || '').trim();
  };
  const raeume = () => $$('.ref-guide__raum', liste);

  /* ── Räume ── */
  function aktualisiereRaum(el, nummer) {
    el.querySelector('[data-rg-nr]').textContent = String(nummer).padStart(2, '0');
    el.querySelector('[data-rg-titel]').textContent = wert(el, 'name') || 'Raum ohne Namen';
    const l = zahl(wert(el, 'laenge'));
    const b = zahl(wert(el, 'breite'));
    const h = zahl(wert(el, 'hoehe'));
    const volumen = el.querySelector('[data-rg-volumen]');
    volumen.textContent = l && b && h ? `Raumvolumen etwa ${deutsch(l * b * h, 0)} m³, Grundfläche etwa ${deutsch(l * b)} m².` : '';
    const komplett = grunddaten(el);
    el.querySelector('[data-rg-zustand]').textContent = komplett ? 'Grunddaten erfasst' : 'Angaben offen';
  }
  function grunddaten(el) {
    const masse = (zahl(wert(el, 'laenge')) && zahl(wert(el, 'breite')) && zahl(wert(el, 'hoehe'))) || false;
    return Boolean(masse && wert(el, 'boden') && wert(el, 'decke'));
  }
  function aktualisiere() {
    const alle = raeume();
    alle.forEach((el, i) => {
      aktualisiereRaum(el, i + 1);
    });
    const n = alle.length;
    $('[data-rg-raumzahl]').textContent = n ? `${n} ${n === 1 ? 'Raum' : 'Räume'} angelegt.` : 'Noch kein Raum angelegt.';
    $('[data-rg-anzahl-feld]').value = n ? String(n) : '';
    const stand = $('[data-rg-stand]');
    stand.hidden = n === 0;
    if (n) {
      const fertig = alle.filter(grunddaten).length;
      $('[data-rg-balken]').style.width = `${Math.round((fertig / n) * 100)}%`;
      $('[data-rg-stand-text]').textContent = `Grunddaten für die Berechnung: ${fertig} von ${n} ${n === 1 ? 'Raum' : 'Räumen'}.`;
    }
  }
  function neuerRaum(daten, kopie = false) {
    const el = vorlage.content.firstElementChild.cloneNode(true);
    el.dataset.rgId = String(naechsteId++);
    liste.append(el);
    if (daten) setzeRaum(el, daten);
    el.querySelector('[data-rg-kopie-hinweis]').hidden = !kopie;
    return el;
  }
  function setzeRaum(el, daten) {
    Object.entries(daten).forEach(([k, v]) => {
      const felder = $$(`[data-k="${k}"]`, el);
      if (felder[0]?.type === 'checkbox') {
        felder.forEach((f) => {
          f.checked = Array.isArray(v) && v.includes(f.value);
        });
      } else if (felder[0]) felder[0].value = v;
    });
  }
  const KEYS = ['name', 'art', 'nutzung', 'beobachtung', 'laenge', 'breite', 'hoehe', 'form', 'personen', 'flaeche', 'boden', 'decke', 'oberflaechen', 'hinweise'];
  const leseRaum = (el) => Object.fromEntries(KEYS.map((k) => [k, wert(el, k)]));

  $('[data-rg-hinzu]').addEventListener('click', () => {
    const anzahl = Math.min(10, Math.max(1, Number.parseInt($('[data-rg-anzahl]').value, 10) || 1));
    raeume().forEach((el) => {
      el.open = false;
    });
    let letzter;
    for (let i = 0; i < anzahl; i++) letzter = neuerRaum();
    aktualisiere();
    speichere();
    letzter?.querySelector('[data-k="name"]')?.focus();
  });
  liste.addEventListener('click', (e) => {
    const el = e.target.closest('.ref-guide__raum');
    if (!el) return;
    if (e.target.closest('[data-rg-weg]')) {
      el.remove();
      aktualisiere();
      speichere();
      $('[data-rg-hinzu]').focus();
    } else if (e.target.closest('[data-rg-kopie]')) {
      const daten = leseRaum(el);
      daten.name = '';
      el.open = false;
      const neu = neuerRaum(daten, true);
      aktualisiere();
      speichere();
      neu.querySelector('[data-k="name"]')?.focus();
    }
  });
  root.addEventListener('input', () => {
    aktualisiere();
    speichere();
  });
  root.addEventListener('change', () => {
    aktualisiere();
    speichere();
  });

  /* ── Schulverzeichnis: erst beim ersten Fokus laden ── */
  const schulFeld = $('[data-rg-feld="schule"]');
  schulFeld.addEventListener(
    'focus',
    async () => {
      try {
        const antwort = await fetch(root.dataset.schulen);
        const schulen = await antwort.json();
        $('#rg-schulen').innerHTML = '';
        const fragment = document.createDocumentFragment();
        schulen.forEach((s) => {
          const option = document.createElement('option');
          option.value = s.name;
          fragment.append(option);
        });
        $('#rg-schulen').append(fragment);
      } catch {
        // Ohne Verzeichnis bleibt das Feld ein freies Textfeld.
      }
    },
    { once: true },
  );

  /* ── Bestandsaufnahme ── */
  // Werte des Block-Settings "bereich" (snippets/referenz-anfrage.liquid); die Mail ist deutsch.
  const BEREICH_TEXT = { kita: 'KiTa oder Kindergarten', schule: 'Schule oder Klassenzimmer' };
  function bestandsaufnahme() {
    const feld = (k) => ($(`[data-rg-feld="${k}"]`)?.value || '').trim();
    const zeilen = ['RAUMGUIDE SCHULE – Bestandsaufnahme', ''];
    zeilen.push(`Schule: ${feld('schule') || 'nicht angegeben'}`);
    const bereich = $('[data-rg-bereich]')?.value || '';
    if (bereich) zeilen.push(`Einsatzbereich: ${BEREICH_TEXT[bereich] || bereich}`);
    if (feld('beobachtung')) zeilen.push('', 'Beobachtung:', feld('beobachtung'));
    const alle = raeume();
    const offen = [];
    if (alle.length) {
      zeilen.push('', `Räume (${alle.length}):`);
      alle.forEach((el, i) => {
        const r = leseRaum(el);
        const nr = String(i + 1).padStart(2, '0');
        zeilen.push('', `${nr} ${r.name || 'Raum ohne Namen'}${r.art ? ` · ${r.art}` : ''}`);
        if (r.nutzung.length) zeilen.push(`   Nutzung: ${r.nutzung.join(', ')}`);
        if (r.beobachtung) zeilen.push(`   Beobachtungen: ${r.beobachtung}`);
        const l = zahl(r.laenge);
        const b = zahl(r.breite);
        const h = zahl(r.hoehe);
        const masse = [];
        if (l && b && h) masse.push(`${deutsch(l, 2)} × ${deutsch(b, 2)} × ${deutsch(h, 2)} m (etwa ${deutsch(l * b * h, 0)} m³)`);
        else if (l || b || h) masse.push(`Länge ${r.laenge || '?'} m, Breite ${r.breite || '?'} m, Höhe ${r.hoehe || '?'} m`);
        if (r.flaeche) masse.push(`Fläche ${r.flaeche} m²`);
        if (r.form) masse.push(`Raumform: ${r.form}`);
        if (r.personen) masse.push(`übliche Personenzahl: ${r.personen}`);
        if (masse.length) zeilen.push(`   Maße: ${masse.join(' · ')}`);
        if (r.boden || r.decke) zeilen.push(`   Boden: ${r.boden || 'offen'} · Decke: ${r.decke || 'offen'}`);
        if (r.oberflaechen) zeilen.push(`   Oberflächen und Einrichtung: ${r.oberflaechen}`);
        if (r.hinweise) zeilen.push(`   Hinweise: ${r.hinweise}`);
        const fehlt = [];
        if (!(l && b && h)) fehlt.push('Maße');
        if (!r.boden) fehlt.push('Boden');
        if (!r.decke) fehlt.push('Decke');
        if (!r.oberflaechen) fehlt.push('Oberflächen');
        if (fehlt.length) offen.push(`Raum ${nr}: ${fehlt.join(', ')}`);
      });
    } else {
      offen.push('Noch kein Raum beschrieben: Raumart, Maße und Oberflächen');
    }
    zeilen.push('', 'Offene Angaben für die Berechnung:');
    zeilen.push(...(offen.length ? offen.map((o) => `– ${o}`) : ['– keine']));
    zeilen.push('', `Kontakt: ${[feld('name'), feld('email'), feld('telefon')].filter(Boolean).join(' · ')}`);
    if (feld('link')) zeilen.push(`Foto- oder Plan-Link: ${feld('link')}`);
    return zeilen.join('\n');
  }

  function zeigeFehler(text, fokus) {
    fehler.textContent = text;
    fehler.hidden = false;
    fokus?.focus();
  }
  $('[data-rg-pruefen]').addEventListener('click', () => {
    fehler.hidden = true;
    const mail = $('[data-rg-feld="email"]');
    if (!$('[data-rg-feld="beobachtung"]').value.trim() && !raeume().length) {
      zeigeFehler('Bitte schildere kurz dein Anliegen oder lege einen Raum an.', $('[data-rg-feld="beobachtung"]'));
      return;
    }
    if (!mail.value.trim() || !mail.checkValidity()) {
      zeigeFehler('Bitte gib eine gültige E-Mail-Adresse an, damit wir antworten können.', mail);
      return;
    }
    const text = bestandsaufnahme();
    $('[data-rg-text]').textContent = text;
    $('[data-rg-body]').value = text;
    eingabe.hidden = true;
    ueberblick.hidden = false;
    $('[data-rg-ueberblick-titel]').focus();
  });
  $('[data-rg-zurueck]').addEventListener('click', () => {
    ueberblick.hidden = true;
    eingabe.hidden = false;
    $('[data-rg-pruefen]').focus();
  });
  form.addEventListener('submit', (e) => {
    if (ueberblick.hidden) {
      // Absenden nur aus dem Überblick heraus, damit die Bestandsaufnahme im Text steht.
      e.preventDefault();
      $('[data-rg-pruefen]').click();
      return;
    }
    $('[data-rg-body]').value = bestandsaufnahme();
    // Alles steht in der Bestandsaufnahme; benannt kaemen Schule, Beobachtung, Telefon usw.
    // ein zweites Mal in die Mail (Grill 2026-10-28). Nach "Zurueck" gibt fennext.js die
    // Namen ueber data-name-weg zurueck (pageshow). Ohne JS bleiben die Einzelfelder.
    $$('[data-in-mail][name]', form).forEach((f) => {
      f.setAttribute('data-name-weg', f.name);
      f.removeAttribute('name');
    });
  });

  /* ── Zwischenstand im Tab ── */
  function speichere() {
    try {
      const daten = {
        felder: Object.fromEntries($$('[data-rg-feld]').map((f) => [f.dataset.rgFeld, f.value])),
        raeume: raeume().map(leseRaum),
      };
      sessionStorage.setItem(SPEICHER, JSON.stringify(daten));
    } catch {
      // Ohne Speicher geht nur der Zwischenstand verloren.
    }
  }
  function lade() {
    try {
      if ($('[data-rg-erfolg]')) {
        sessionStorage.removeItem(SPEICHER);
        return;
      }
      const daten = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null');
      if (!daten) return;
      Object.entries(daten.felder || {}).forEach(([k, v]) => {
        const f = $(`[data-rg-feld="${k}"]`);
        if (f && !f.value) f.value = v;
      });
      (daten.raeume || []).forEach((r) => {
        neuerRaum(r).open = false;
      });
      if ((daten.raeume || []).length) $('[data-rg-raeume]').open = true;
    } catch {
      sessionStorage.removeItem(SPEICHER);
    }
  }
  lade();
  aktualisiere();
})();
